var unit_types ={
  unit_types: {
    condo: {
    txt_id: "condo",
    name: "Appartment",
    description: null
    },
    townhouse: {
    txt_id: "townhouse",
    name: "Townhouse",
    description: null
    },
    house: {
    txt_id: "house",
    name: "House",
    description: "House"
    },
    top_flor: {
    txt_id: "top_flor",
    name: "Top Flor",
    description: "Top Flor"
    },
    main_flor: {
    txt_id: "main_flor",
    name: "Main Flor",
    description: "Main Flor"
    },
    basement: {
    txt_id: "basement",
    name: "Basement",
    description: "Basement"
    },
    shared_space: {
    txt_id: "shared_space",
    name: "Shared Space",
    description: "Shared Space"
    }
    }
}

module.exports = unit_types
